import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSession as useAuth, Loading } from '@cordata/buffet';
import { useLocation } from 'react-router-dom';

import KSImpersonation from '~/components/KSImpersonation/form';
import gateKeep from '~/utils/gate-keeper';
import { sessionInstance as session } from '~/utils';
import { hasAzureLogout } from '../../utils/ms-ad';

const Destinations = ({ destinations }) => (
  destinations &&
  !destinations.map(d => d.permission).includes('hasAppNavigator') &&
    !destinations.map(d => d.permission).includes('hasAppDivisionAdmin')
    ? (
      destinations.filter(d => d.name !== 'Gatekeeper').map(d => (
        <div key={d.name}>
          <a href={d.url}>
            {d.name} - {d.description}
          </a>
        </div>
      ))
    ) : (<Loading />));

Destinations.propTypes = {
  destinations: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

const Home = () => {
  const {
    current,
  } = useAuth();
  const [destinations, setDestinations] = useState([]);
  const location = useLocation();

  const fetchDestinations = () => session
    .get('/destinations')
    .then(({ data: { data: r } }) => setDestinations(r));

  useEffect(() => {
    if (current) {
      localStorage.setItem('doAzureLogout', hasAzureLogout(current));
      fetchDestinations();
    }
  }, [current]);

  useEffect(() => {
    if (current && !!destinations.length) {
      gateKeep(
        destinations,
        location.state && location.state.skipPasswordCheck
          ? false
          : (
            current.attributes.passwordExpiresIn <= 7 ||
            current.attributes.passwordResetRequired
          ),
        current.attributes.permissions,
      );
    }
  }, [current, destinations]);
  return (
    <>
      <Destinations destinations={destinations} />
      <KSImpersonation />
    </>
  );
};

export default Home;
